import React, { useGlobal, useState, useRef } from "reactn";
import { LeftMsgArrow, RightMsgArrow } from "../../../../assets";
import { format } from "date-fns";
import ScrollToBottom from "react-scroll-to-bottom";
import { PPIcon, ParentMessage, Megaphone } from "../../../../assets";
import SendMessage from "./MessageBar";
import "../messaging.css";
import { findUserData } from "./commUtil";
import axios from "axios";

const Chat = ({ messageThread, userInfoLT, setRefetch, insertMessage }) => {
  const [aiSuggestion, setAiSuggestion] = useState("");
  const [isGeneratingSuggestion, setIsGeneratingSuggestion] = useState(false);
  const messageInputRef = useRef(null);

  const dsUser = useGlobal("dsUser")[0];       //dsUser is the partner, since this page is only on the partner-site!

  const generateAISuggestion = async () => {
    if (!messageThread || !messageThread.messages || messageThread.messages.length === 0) {
      return;
    }

    setIsGeneratingSuggestion(true);
    setAiSuggestion("");

    const clearAISuggestion = () => {
  setAiSuggestion("");
};

    try {
      const recentMessages = messageThread.messages
        .slice(-10)
        .map(msg => ({
          body: msg.body,
          direction: msg.direction,
          dateCreated: msg.dateCreated
        }));

      const parentInfo = messageThread.user || {
        displayName: messageThread.userName,
        email: messageThread.email,
        phone: messageThread.phone
      };

      const context = {
        programName: messageThread.listingProductName,
        programType: messageThread.listingTable,
        enrollmentStatus: messageThread.stage
      };

      const response = await axios.post(`${process.env.REACT_APP_API}/partners/connections/ai-message-suggestion`, {
        messageHistory: recentMessages,
        parentInfo: parentInfo,
        context: context
      });

      if (response.data.success) {
        setAiSuggestion(response.data.data.suggestion);
      } else {
        console.error("Failed to generate AI suggestion:", response.data.message);
      }
    } catch (error) {
      console.error("Error generating AI suggestion:", error);
    } finally {
      setIsGeneratingSuggestion(false);
    }
  };

  const acceptAISuggestion = () => {
    if (aiSuggestion && messageInputRef.current) {
      messageInputRef.current.value = aiSuggestion;
      setAiSuggestion("");
      messageInputRef.current.dispatchEvent(new Event('input', { bubbles: true }));
    }
  };


  const clearAISuggestion = () => {
    setAiSuggestion("");
  };

  if (!messageThread || !messageThread.messages) return;

  // const partnerPhoto = dsUser.photo
  //   ? `${process.env.REACT_APP_DS_FILES_S3}/${dsUser.photo}`
  //   : Megaphone;
  const partnerPhoto = Megaphone;  //dsUser (in this case) doesn't have photo field, nor the organization's logo.

  const userInfo = messageThread.dsUserId && userInfoLT[messageThread.dsUserId]; //get user profile for photo only!
  const userPhoto = userInfo && userInfo.photo
    ? `${process.env.REACT_APP_DS_FILES_S3}/${userInfo.photo}`
    : ParentMessage;

  // Most recent messages appear at the end of array.
  const messages = messageThread.messages.slice().reverse();

  const ascendingOrder = (a,b) => (new Date(a.dateCreated) - new Date(b.dateCreated));

  return (
    <div className="message-center">
      <ScrollToBottom className="partnermsg">
        {messages.sort(ascendingOrder).map((msg, key) => {
          if (msg.direction === "inbound") {
            return (
              <div key={key} className="leftsidemsg">
                <div className="row">
                  <div className="col-2">
                    <div
                      className="divforimg activecircle"
                      style={{
                        backgroundImage: `url(${userPhoto})`,
                        backgroundPosition: "center",
                        width: "45px",
                        height: "45px",
                        borderRadius: "50%",
                        backgroundSize: "cover"
                      }}
                    >
                      {/* <div className="mincircle" /> */}
                    </div>
                  </div>
                  <div className="col-10">
                    <div className="msg">
                      <p>
                        <img
                          src={LeftMsgArrow}
                          className="leftmsgarrow"
                          alt=""
                        />
                        {msg.body}{" "}
                      </p>

                      <p className="time">
                        {format(
                          new Date(msg.dateCreated),
                          "LLL dd, yyyy - hh:mm:ss aa"
                        )}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            );
          } else {
            return (
              <div key={key} className="floatright">
                <div className="rightsidemsg">
                  <div className="row">
                    <div className="col-10">
                      <div className="msg">
                        <p>
                          <img
                            src={RightMsgArrow}
                            className="rightmsgarrow"
                            alt=""
                          />
                          {msg.body}{" "}
                        </p>

                        <p className="time">
                          {format(
                            new Date(msg.dateCreated),
                            "LLL dd, yyyy - hh:mm:ss aa"
                          )}
                        </p>
                      </div>
                    </div>

                    <div className="col-2">
                      <div
                        className="divforimg"
                        style={{
                          backgroundImage: `url(${partnerPhoto})`,
                          backgroundPosition: "center",
                          width: "45px",
                          height: "45px",
                          borderRadius: "50%",
                          backgroundSize: "cover"
                        }}
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
            );
          }
        })}
      </ScrollToBottom>


      <SendMessage
        phone={messageThread.phone}
        setRefetch={setRefetch}
        insertMessage={insertMessage}
        generateAISuggestion={generateAISuggestion}
        isGeneratingSuggestion={isGeneratingSuggestion}
        messageInputRef={messageInputRef}
        messageThread={messageThread}
        aiSuggestion={aiSuggestion}
        onAcceptSuggestion={acceptAISuggestion}
        onClearSuggestion={clearAISuggestion}
      />
    </div>
  );
};

export default Chat;
